@switch (status()) {
  @case ('laedt') {
    <div class="details-historie-status__skeleton" role="status" aria-busy="true">
      <span class="sr-only">{{ 'common.detailsHistorie.status.laedt' | translate }}</span>
      @for (zeile of zeilen; track zeile) {
        <div class="details-historie-status__zeile" aria-hidden="true"></div>
      }
    </div>
  }
  @case ('fehler') {
    <div class="details-historie-status__fehler">
      <p class="details-historie-status__text" role="alert">
        {{ fehlerText() || ('common.detailsHistorie.status.fehler' | translate) }}
      </p>
      <button type="button" class="details-historie-status__retry" (click)="retry.emit()">
        {{ 'common.retry' | translate }}
      </button>
    </div>
  }
}
